/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface OrgUnauthorizationSpec { 
    /**
     * It will delete the Seed OAuth app, cleans credentials from all allowed regions from shadow account and master region from admin account. It will override all other flags - if this true others will not be respected.
     */
    deep_clean?: boolean;
    /**
     * Regions which are supposed to be cleaned in the shadow account
     */
    delete_in_shadow_account?: OrgUnauthorizationSpec.DeleteInShadowAccountEnum;
    /**
     * If true - cleans the secrets from Admin account. Else skip.
     */
    delete_secrets_from_admin_account?: boolean;
    /**
     * If true - cleans the secrets from Shadow account. Else skip.
     */
    delete_secrets_from_shadow_account?: boolean;
    /**
     * If true - Seed OAuth app will be deleted using the credentials of Seed OAuth app.
     */
    delete_seed_oauth_app?: boolean;
    /**
     * When \'delete_in_shadow_account\' is \'SINGLE_REGION\' - it should mention region which needs to be cleaned.
     */
    delete_shadow_account_region?: string;
    /**
     * If false - task will fail if any operation fails. Else task will succeed with warning in case of failures.
     */
    fail_when_error?: boolean;
    /**
     * This will update the state of Seed OAuth App to deleted. Once operator has verified - this API again need to be called with true for this flag so property in database will be updated.
     */
    mark_seed_oauth_app_deleted?: boolean;
    /**
     * Org id
     */
    org_id: string;
    service_type: ServiceTypeEnum;
}
export namespace OrgUnauthorizationSpec {
    export type DeleteInShadowAccountEnum = 'ALL_REGIONS' | 'ALL_ACTIVE_REGIONS' | 'SINGLE_REGION';
    export const DeleteInShadowAccountEnum = {
        ALL_REGIONS: 'ALL_REGIONS' as DeleteInShadowAccountEnum,
        ALL_ACTIVE_REGIONS: 'ALL_ACTIVE_REGIONS' as DeleteInShadowAccountEnum,
        SINGLE_REGION: 'SINGLE_REGION' as DeleteInShadowAccountEnum
    };
}


